module.exports = __webpack_public_path__ + "static/media/bc.b7161208.svg";